import React from 'react';
import styled from "styled-components";
import { Drawer } from "antd";

export const FullPageDrawerInner = styled.div<{padding?: string}>`
  padding: ${props => props.padding ? props.padding : '20px 0px'};
`;

